import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css";
import { OrderProvider } from "./pages/pos/OrderContext";
import { EmpOrderProvider } from "./Salespos/EmpOrderContext";
import { SettingsProvider } from "./pages/kitchen/SettingsContext";
import { AuthProvider } from "./context/AuthContext";
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  // <React.StrictMode>
    <AuthProvider>
    <OrderProvider>
      <EmpOrderProvider>
        <SettingsProvider>
          <App />
        </SettingsProvider>
      </EmpOrderProvider>
    </OrderProvider>
    </AuthProvider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
